import { render, staticRenderFns } from "./OverrideBusinessHoursModel.vue?vue&type=template&id=4fe872fe&scoped=true"
import script from "./OverrideBusinessHoursModel.vue?vue&type=script&lang=js"
export * from "./OverrideBusinessHoursModel.vue?vue&type=script&lang=js"
import style0 from "./OverrideBusinessHoursModel.vue?vue&type=style&index=0&id=4fe872fe&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe872fe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4fe872fe')) {
      api.createRecord('4fe872fe', component.options)
    } else {
      api.reload('4fe872fe', component.options)
    }
    module.hot.accept("./OverrideBusinessHoursModel.vue?vue&type=template&id=4fe872fe&scoped=true", function () {
      api.rerender('4fe872fe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/company/onboarding/OverrideBusinessHoursModel.vue"
export default component.exports